import React from "react";
import "./Copyrights.scss";

const Copyrights: React.FC = () => {
  const currentYear = new Date().getFullYear();
  
  return (
    <div className="copyrights">
      <p>Copyright © {currentYear} Nagwa</p>
      <p>All rights reserved</p>
    </div>
  );
};

export default Copyrights;
